/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Event helper class
 **/
define([], function(){

	const destroyedPrototypes = new WeakMap();
	const emptyFunction = function(){};
	class MemUtil {
		/**
		 * Destroy an object - clear all attribute and set all functions to empty functions
		 */
		static destroy(object) {
			let destroyedProto = destroyedPrototypes.get(object.__proto__);
			if (!destroyedProto){
				destroyedProto = {};
				destroyedPrototypes.set(object.__proto__, destroyedProto);
				for (let prop in object.__proto__) {
					if (typeof(object.__proto__[prop]) === 'function'){
						destroyedProto[prop] = emptyFunction;
					}
				}
			}
			for (let prop in object) {
				// clear everything referenced by this object in case someone is still holding on to it.
				if (Object.prototype.hasOwnProperty.call(object, prop)) {
					if (typeof(object[prop]) === 'function'){
						object[prop] = emptyFunction;
					} else {
						delete object[prop];
					}
				}
			}
			object.__proto__ = destroyedProto;
			object.__destroyed__ = true;
		}

		static isDestroyed(object){
			return object.__destroyed__;
		}
	}
	return MemUtil;
});
